import React, { FC } from "react";

import { Typography } from "../../Fundamentals/Typography/Typography";
import FormLabel, { IFormLabelProps } from "./FormLabel";

export interface IFilterFormLabelProps extends IFormLabelProps {
  name?: string;
  total?: string;
}

const FilterFormLabel: FC<IFilterFormLabelProps> = ({
  name,
  total,
  children,
  ...label
}) => {
  return (
    <FormLabel {...label}>
      {children}
      <Typography classes={{ root: "form-check-label__name" }}>
        {name}
      </Typography>
      <Typography classes={{ root: "form-check-label__total" }}>
        {total}
      </Typography>
    </FormLabel>
  );
};

export default FilterFormLabel;
